var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTjs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2757_5676",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2757_5676)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H23V23H0V0Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V7.66667H23V0H0Z",
    fill: "#C51918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.333V22.9997H23V15.333H0Z",
    fill: "#409100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4607 14.9282C11.1641 14.9395 10.9666 14.5218 10.9666 14.5218L11.2707 14.4173C11.2896 14.15 11.4271 14.0078 11.4271 14.0078C11.518 14.0857 11.6163 14.4368 11.6163 14.4368L11.8768 14.4856C11.8768 14.4856 11.7573 14.9169 11.4607 14.9282ZM10.0126 15.0477C9.72009 15.1139 9.48085 14.7369 9.48085 14.7369L9.77106 14.577C9.76188 14.3088 9.88323 14.1425 9.88323 14.1425C9.98139 14.2027 10.1153 14.5321 10.1153 14.5321H10.3784C10.3784 14.5321 10.3051 14.9814 10.0126 15.0477ZM8.97217 15.4273L9.10466 16.0564C9.79187 15.8084 10.5895 15.6838 11.4975 15.6838C12.4054 15.6838 13.203 15.8084 13.8902 16.0564L14.0227 15.4273C13.2896 15.1628 12.4479 15.0313 11.4975 15.0313C10.547 15.0313 9.70533 15.1628 8.97217 15.4273ZM13.4695 14.8021C13.4695 14.8021 13.2302 15.1791 12.9377 15.1129C12.6452 15.0467 12.5719 14.5974 12.5719 14.5974H12.835C12.835 14.5974 12.9689 14.268 13.0671 14.2077C13.0671 14.2077 13.1884 14.374 13.1792 14.6423L13.4695 14.8021Z",
    fill: "#FFBB00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4702 13.1271C11.4702 13.1271 11.1331 14.1557 10.6022 14.2352C10.0713 14.3148 9.80166 13.6502 9.80166 13.6502C9.80166 13.6502 9.76688 14.3413 9.13637 14.6077C8.50587 14.8741 8.17386 13.8098 8.17386 13.8098C8.17386 13.8098 8.50211 14.2013 9.01123 14.0307C9.52035 13.8601 9.72131 13.2301 9.72131 13.2301C9.72131 13.2301 10.0981 13.8869 10.6022 13.5585C11.1063 13.2301 11.3852 12.8287 11.3852 12.4436V11.2918C11.3852 11.2918 11.2552 10.9931 11.0296 10.9931C10.8039 10.9931 10.741 11.2049 10.741 11.2049C10.741 11.2049 10.6529 10.0066 11.4644 9.93259L11.4643 9.92969L11.4868 9.93084L11.5092 9.92969L11.5092 9.93259C12.3206 10.0066 12.2326 11.2049 12.2326 11.2049C12.2326 11.2049 12.1696 10.9931 11.944 10.9931C11.7183 10.9931 11.5883 11.2918 11.5883 11.2918V12.4436C11.5883 12.8287 11.8672 13.2301 12.3713 13.5585C12.8754 13.8869 13.2522 13.2301 13.2522 13.2301C13.2522 13.2301 13.4532 13.8601 13.9623 14.0307C14.4714 14.2013 14.7997 13.8098 14.7997 13.8098C14.7997 13.8098 14.4676 14.8741 13.8371 14.6077C13.2066 14.3413 13.1719 13.6502 13.1719 13.6502C13.1719 13.6502 12.9022 14.3148 12.3713 14.2352C11.8404 14.1557 11.5033 13.1271 11.5033 13.1271L11.4868 11.7695L11.4702 13.1271ZM11.4627 10.2552C11.0884 10.2552 11.0126 10.6778 11.0126 10.6778C11.3422 10.6778 11.4627 10.8693 11.4627 10.8693C11.4627 10.8693 11.7068 10.6778 11.9525 10.6778C11.9525 10.6778 11.8371 10.2552 11.4627 10.2552Z",
    fill: "#FFBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55353 12.4566L7.12127 12.6201C7.01644 10.9876 7.52038 9.44315 8.57945 8.02798C10.1374 5.9462 13.2922 6.14898 14.6351 8.04733C15.4024 9.13192 15.7954 10.6348 15.8332 12.5126L14.3962 12.564C14.3672 11.1256 14.092 10.0728 13.5894 9.36244C12.7883 8.22999 10.5659 8.08714 9.59702 9.38179C8.81783 10.423 8.48788 11.4342 8.55353 12.4566Z",
    fill: "#FFBB00"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2757_5676)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2757_5676",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTjs);
export default __webpack_public_path__ + "static/media/TJS.146d6b0f325f772d3f8de9e30f9cb661.svg";
export { ForwardRef as ReactComponent };